import { Button as MaterialUiButton } from '@mui/material'

import { BaseButtonProps } from './BaseButton.types'

import './BaseButton.scss'

const BaseButton: React.FC<BaseButtonProps> = ({ type, children, onClick, sx, ...props }): JSX.Element => {
	switch (type) {
		case 'contained':
			return (
				<MaterialUiButton variant={type} className='button-contained' sx={sx} onClick={onClick} {...props}>
					{children}
				</MaterialUiButton>
			)

		case 'text':
			return (
				<MaterialUiButton variant={type} className='button-text' sx={sx} onClick={onClick} {...props}>
					{children}
				</MaterialUiButton>
			)

		case 'outlined':
			return (
				<MaterialUiButton variant={type} onClick={onClick} sx={sx} {...props}>
					{children}
				</MaterialUiButton>
			)
	}
}

export default BaseButton
